/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IRefinerSortOption } from '@msdyn365-commerce/components';

import { IInvoicesListResources } from '../invoices-list.props.autogenerated';
import { InvoiceSortOption } from './sort-option';

export function mapSortOptionIntoIRefinerSortOption(sortOption: InvoiceSortOption, resources: IInvoicesListResources): IRefinerSortOption {
    switch (sortOption) {
        case InvoiceSortOption.NewestToOldest:
            return {
                label: resources.newestToOldestSortOptionLabel,
                value: InvoiceSortOption.NewestToOldest
            };
        case InvoiceSortOption.OldestToNewest:
            return {
                label: resources.oldestToNewestSortOptionLabel,
                value: InvoiceSortOption.OldestToNewest
            };
        default:
            throw new Error(`Invalid invoice sort option: ${sortOption}`);
    }
}

export function mapIRefinerSortOptionIntoSortOption(refinerSortOption?: IRefinerSortOption): InvoiceSortOption | undefined {
    if (!refinerSortOption) {
        return;
    }

    if (refinerSortOption.value === InvoiceSortOption.NewestToOldest) {
        return InvoiceSortOption.NewestToOldest;
    }

    if (refinerSortOption.value === InvoiceSortOption.OldestToNewest) {
        return InvoiceSortOption.OldestToNewest;
    }

    return;
}
